import { GetDamagedImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQuery.type';
import { getDamagedImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQueryFunctions';
import { getInitialVisitImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getInitialVisitImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getDamagedImageTabsAlertsQueryOptions = (
  params: GetDamagedImageTabsAlertsQueryParamType,
) => {
  if (params.type && params.type === 'initial') {
    return queryOptions({
      queryKey: ['GET_DAMAGED_IMAGE_TABS_ALERTS', params],
      queryFn: () => getInitialVisitImageTabsAlertsQueryFunctions(params),
    });
  }
  return queryOptions({
    queryKey: ['GET_DAMAGED_IMAGE_TABS_ALERTS', params],
    queryFn: () => getDamagedImageTabsAlertsQueryFunctions(params),
  });
};

export default getDamagedImageTabsAlertsQueryOptions;
